(ns dashboard.services.answers
  (:require [dashboard.notifications :as notifications]
            [dashboard.services.http-config :as http-config]
            [dashboard.ui :as ui]
            [io.repliance.schemas.core :as schemas]
            [re-frame.core :as rf]))

;; Subs

(rf/reg-sub
  ::answers
  (fn [db [_ questionnaire-id question-id]]
    (get-in db [:questionnaires questionnaire-id :answers-by-question question-id])))

;; Events

(rf/reg-event-fx
  ::get-answers
  (fn [{:keys [db]} [_ questionnaire-id question-id]]
    {:db (assoc-in db [:questionnaires questionnaire-id :answers-by-question question-id :loading] true)
     :http-xhrio {:method          :get
                  :uri             (str "/api/questions/question/" question-id "/answers")
                  :timeout         http-config/timeout
                  :format          http-config/transit-request-format
                  :response-format http-config/transit-response-format
                  :on-success      [::set-answers questionnaire-id question-id]
                  :on-failure      [::ui/set-error "Failed to fetch answers"]}}))

(rf/reg-event-db
  ::set-answers
  (fn [db [_ questionnaire-id question-id answers]]
    (assoc-in db [:questionnaires questionnaire-id :answers-by-question question-id] {:loading false
                                                                                      :data answers})))

(rf/reg-event-fx
  ::add-and-select-answer
  (fn [{:keys [db]} [_ questionnaire-id question {:keys [question-id applied-analysis-version-ids id] :as answer}]]
    (let [db (-> db
                 (update-in [:questionnaires questionnaire-id :answers-by-question question-id :data] conj answer)
                 (update-in [:questionnaires questionnaire-id :questions :data] (fn [questions]
                                                                                  (mapv (fn [question]
                                                                                          (if (= (:id question) (:question-id answer))
                                                                                            (assoc question :selected-answer answer)
                                                                                            question))
                                                                                        questions))))]
      {:db (if (seq applied-analysis-version-ids)
             (-> db
                 (update-in [:applied-analyses :data] (fn [data]
                                                        (update-vals data (fn [applied-analyses]
                                                                            (map (fn [{:keys [version-id] :as applied-analysis}]
                                                                                   (if (contains? applied-analysis-version-ids version-id)
                                                                                     (update applied-analysis :answer-ids (fnil conj #{}) id)
                                                                                     applied-analysis))
                                                                                 applied-analyses)))))
                 (assoc-in [:applied-analyses :answer-id->applied-analyses id] (mapcat (fn [[_construct-id applied-analyses]]
                                                                                         (filter (fn [{:keys [version-id]}]
                                                                                                   (contains? applied-analysis-version-ids version-id))
                                                                                                 applied-analyses))
                                                                                       (-> db :applied-analyses :data))))
             db)
       :fx [[:dispatch [::notifications/add {:message "Answer created and selected"}]]
            (when (and (= schemas/not-yet-evaluated-answer-scope (-> question :answer-scope :content))
                       (seq applied-analysis-version-ids))
              [:dispatch [::set-answer-scope questionnaire-id #{(:id question)} schemas/completed-by-analyst-answer-scope "create-answer-with-applied-analysis"]])]})))

(rf/reg-event-fx
  ::set-answer-scope
  (fn [_ [_ questionnaire-id question-ids answer-scope action]]
    {:http-xhrio {:method :post
                  :uri (str "/api/questions/answer-scope")
                  :params {:question-ids question-ids
                           :answer-scope answer-scope
                           :action action}
                  :format http-config/transit-request-format
                  :response-format http-config/transit-response-format
                  :on-success [::set-answer-scope-success questionnaire-id]
                  :on-failure [::ui/set-error "Failed to set answer scope for question"]}}))

(rf/reg-event-fx
  ::set-answer-scope-success
  (fn [{:keys [db]} [_ questionnaire-id {:keys [question-ids answer-scope all-answer-scopes]}]]
    {:db (-> db
             (update-in [:questionnaires questionnaire-id :questions :data] (fn [questions]
                                                                              (mapv (fn [question]
                                                                                      (if (question-ids (:id question))
                                                                                        (assoc question :answer-scope answer-scope)
                                                                                        question))
                                                                                    questions)))
             (assoc :answer-scopes all-answer-scopes))
     :dispatch [::notifications/add {:message (str "Answer scope set for "
                                                   (if (> (count question-ids) 1)
                                                     "questions"
                                                     "question"))}]}))
